import { useState } from "react";
const PaymentHistory = () => {

    const paymentHistory = [
        {
            Date: "12 Sep 2025",
            Amount: "1,200",
            Service: "Dr. Roy (Dermatologist)",
            Status: "Pending",
            id: "TXN12345"
        },
        {
            Date: "15 Sep 2025",
            Amount: "900",
            Service: "Dr. Smith (Cardiologist)",
            Status: "Cancelled",
            id: "TXN12346"
        },
        {
            Date: "18 Sep 2025",
            Amount: "2,500",
            Service: "Health Checkup Package",
            Status: "Completed",
            id: "TXN12347"
        },
        {
            Date: "20 Sep 2025",
            Amount: "1,750",
            Service: "Dr. Mehta (Neurologist)",
            Status: "Completed",
            id: "TXN12348"
        },
        {
            Date: "22 Sep 2025",
            Amount: "600",
            Service: "Lab Test (Blood & Urine)",
            Status: "Completed",
            id: "TXN12349"
        },
        {
            Date: "18 Sep 2025",
            Amount: "2,500",
            Service: "Health Checkup Package",
            Status: "Completed",
            id: "TXN12347"
        },
        {
            Date: "20 Sep 2025",
            Amount: "1,750",
            Service: "Dr. Mehta (Neurologist)",
            Status: "Completed",
            id: "TXN12348"
        },
        {
            Date: "22 Sep 2025",
            Amount: "600",
            Service: "Lab Test (Blood & Urine)",
            Status: "Completed",
            id: "TXN12349"
        }
    ];

    const itemsPerPage = 5;
    const [currentPage, setCurrentPage] = useState(1);

    // calculate pagination
    const totalPages = Math.ceil(paymentHistory.length / itemsPerPage);
    const startIndex = (currentPage - 1) * itemsPerPage;
    const currentItems = paymentHistory.slice(startIndex, startIndex + itemsPerPage);

    return (
        <>
            <div className="container">
                
                <div className="profile-header">
                    <h2>Payment History</h2>
                </div>


                <div className="third-section">

                    <div className="payment-history-card">
                        <div className="paymentTopSec">
                            <h3>Payment History</h3>
                        </div>

                        {currentItems.map((d, i) => (
                            <div className="payment-record" key={i}>
                                <div className="payment-info">
                                    <p>
                                        <b>Date:</b> {d.Date}
                                    </p>
                                    <p style={{ marginTop: "5px" }}>
                                        <b>Amount:</b> ₹{d.Amount}
                                    </p>
                                </div>
                                <div className="payment-info">
                                    <p>
                                        <b>Doctor / Service:</b> {d.Service}
                                    </p>
                                </div>
                                <div className={`payment-status ${d.Status.toLowerCase()}`}>
                                    {d.Status}
                                </div>
                                <div className="payment-id">#{d.id}</div>
                            </div>
                        ))}

                        {/* Pagination controls */}
                        <div className="pagination">
                            {Array.from({ length: totalPages }, (_, i) => (
                                <button
                                    key={i}
                                    className={`page-btn ${currentPage === i + 1 ? "active" : ""}`}
                                    onClick={() => setCurrentPage(i + 1)}
                                >
                                    {i + 1}
                                </button>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default PaymentHistory;